// Tentative_Schedule.jsx — with DRAG & DROP support
import React, { useEffect, useMemo, useRef, useState } from "react";
import Axios from "axios";
import { Host } from "./../../../App";
import { Data } from "../../../Pivot/Pivot";
import "./Tentative_Schedule.css";

/* ----------------- small date helpers ----------------- */
function fmt(d) {
  const dt = new Date(d + "T00:00:00");
  return dt.toLocaleDateString(undefined, { day: "2-digit", month: "short" });
}
function todayISO() {
  return new Date().toISOString().slice(0, 10);
}
function addDaysISO(iso, n) {
  const d = new Date(iso + "T00:00:00");
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
}
function datesBetweenISO(start, end) {
  const out = [];
  let d = start;
  while (d <= end) {
    out.push(d);
    d = addDaysISO(d, 1);
  }
  return out;
}

// Generate a stable Tentative_ID if backend doesn't assign one
function genTentativeId({ internalPartNo, date }) {
  const base = (internalPartNo || "TENT").replace(/\s+/g, "-");
  return `${base}-${date}-${Math.random().toString(36).slice(2, 7)}`;
}

export default function Tentative_Schedule() {
  const token = window.localStorage.getItem("acessToken");
  const storedName = window.localStorage.getItem("Name");
  const user = storedName ? JSON.parse(storedName) : "";
  const host = Host;

  /* ----------------- range + data ----------------- */
  const [start, setStart] = useState(todayISO());
  const [end, setEnd] = useState(addDaysISO(todayISO(), 14));

  const [rowsTent, setRowsTent] = useState([]);
  const [rowsDaily, setRowsDaily] = useState([]);
  const [part_dataset, setpart_dataset] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [employees, setEmployees] = useState([]);
  const [employees_capability, setemployees_capability] = useState([]);
  const [Machine_list, setMachine_list] = useState([]);

  const [shift, setShift] = useState([
    "Night_Operators",
    "Management",
    "Morning_Operators",
    "Woodshop",
    "WFH",
  ]);

  const [presentCounts, setPresentCounts] = useState({});
  const [presentByDate, setPresentByDate] = useState({});

  /* ----------------- dialogs ----------------- */
  const [openSend, setOpenSend] = useState(false);
  const [sendForm, setSendForm] = useState({
    date: "",
    employee: "",
    partNo: "",
    internalPartNo: "",
    qty: 0,
    customer: "",
    description: "",
    Work_Station: "",
    Tentative_ID: "",
  });

  const [openManual, setOpenManual] = useState(false);
  const [manualForm, setManualForm] = useState({
    date: todayISO(),
    employee: "",
    internalPartNo: "",
    partNo: "",
    customer: "",
    description: "",
    qty: 0,
    Work_Station: "",
  });

  const [openCapability, setOpenCapability] = useState(false);
  const [rolePopupDate, setRolePopupDate] = useState(null);

  /* ----------------- DRAG & DROP STATE ----------------- */
  const [draggedItem, setDraggedItem] = useState(null); // { type: 'daily'|'tentative', data: {...}, sourceDate: '...' }
  const [dropTarget, setDropTarget] = useState(null); // { type: 'daily'|'tentative', date: '...' }
  const [isDragging, setIsDragging] = useState(false);

  // Confirmation dialog for cross-section drops
  const [dropConfirm, setDropConfirm] = useState(null); // { show, action: 'dailyToTent'|'tentToDaily', item, targetDate, onConfirm }

  /* ----------------- produced editing ----------------- */
  const [prodEdit, setProdEdit] = useState({});
  const saveTimers = useRef({});

  const keyForDaily = (r) =>
    String(
      r.Sr_No || `${r.Date}|${r.Operator}|${r.Internal_Part_No}|${r.Part_No}`
    );

  /* ----------------- fetch boot data ----------------- */
  useEffect(() => {
    fetchBoth();
  }, [start, end]);

  useEffect(() => {
    Axios.get(`https://${Host}/realapi/get/Machines/${token}`)
      .then(({ data }) => setMachine_list(data || []))
      .catch(() => setMachine_list([]));
  }, [token]);

  useEffect(() => {
    Axios.get(`https://${Host}/api/employees_all/${token}`)
      .then(({ data }) => {
        setEmployees(data || []);
      })
      .catch(() => setEmployees([]));
  }, [token]);

  useEffect(() => {
    Axios.get(`https://${Host}/employees/capabilities/${token}`)
      .then(({ data }) => setemployees_capability(data || []))
      .catch(() => setemployees_capability([]));
  }, [token]);

  useEffect(() => {
    Axios.get(`https://${host}/realapi/get/part_dataset/${token}`)
      .then((data) =>
        setpart_dataset(Array.isArray(data.data) ? data.data : [])
      )
      .catch(() => setpart_dataset([]));
  }, [host, token]);

  const fetchBoth = async () => {
    setLoading(true);
    setError("");
    try {
      const [tent, daily] = await Promise.all([
        Axios.get(`https://${Host}/Rigid/tentative/list`, {
          params: { start, end },
        }),
        Axios.get(`https://${Host}/Rigid/daily/list`, {
          params: { start, end },
        }),
      ]);
      setRowsTent(Array.isArray(tent.data?.rows) ? tent.data.rows : []);
      setRowsDaily(Array.isArray(daily.data?.rows) ? daily.data.rows : []);
    } catch (e) {
      setError(e?.response?.data?.message || e.message || "Failed to load.");
    } finally {
      setLoading(false);
    }
  };

  const buildShiftParam = (s) =>
    (Array.isArray(s) ? s : String(s).split(","))
      .map((v) => v.trim())
      .filter(Boolean)
      .map((v) => v.replace(/'/g, "\\'"))
      .join("','");

  useEffect(() => {
    let cancelled = false;
    async function run() {
      if (!shift || shift.length <= 1) {
        setPresentCounts({});
        setPresentByDate({});
        return;
      }
      const dates = datesBetweenISO(start, end);
      const results = await Promise.all(
        dates.map(async (Date) => {
          try {
            const queryParams = { shift: buildShiftParam(shift), token, Date, user };
            const { data } = await Axios.get(
              `https://${Host}/api/employees`,
              { params: queryParams }
            );
            const filtered = Array.isArray(data)
              ? data.filter((e) => e.Name && e.Name.length > 1)
              : [];
            return [Date, filtered];
          } catch {
            return [Date, []];
          }
        })
      );
      if (!cancelled) {
        const countsMap = {};
        const byDateMap = {};
        for (const [Date, list] of results) {
          countsMap[Date] = list.length;
          byDateMap[Date] = list;
        }
        setPresentCounts(countsMap);
        setPresentByDate(byDateMap);
      }
    }
    run();
    return () => {
      cancelled = true;
    };
  }, [shift, start, end, token, user]);

  const getPositionSummaryForDate = (dateStr) => {
    const list = presentByDate[dateStr] || [];
    const summary = {
      rigid: 0,
      flex: 0,
      floater: 0,
      other: {},
    };
    list.forEach((emp) => {
      const raw = (emp.Position || "").trim();
      if (!raw) return;
      const pos = raw.toLowerCase();
      if (pos === "rigid operator") {
        summary.rigid += 1;
      } else if (pos === "flex operator" || pos === "flex operator ") {
        summary.flex += 1;
      } else if (pos === "floater") {
        summary.floater += 1;
      } else {
        summary.other[raw] = (summary.other[raw] || 0) + 1;
      }
    });
    return summary;
  };

  const producedByTentative = useMemo(() => {
    const m = {};
    for (const r of rowsDaily) {
      const tid =
        r.Tentative_ID ||
        r.tentativeID ||
        r.tentative_id ||
        r.tentativeId;
      if (!tid) continue;
      const scheduledQty = Number(r.Target || 0);
      if (!m[tid]) m[tid] = 0;
      m[tid] += scheduledQty;
    }
    return m;
  }, [rowsDaily]);

  const byDateTentFiltered = useMemo(() => {
    const out = {};
    for (const r of rowsTent) {
      const d = r.Date?.slice(0, 10);
      if (!d) continue;
      const tid =
        r.Tentative_ID ||
        r.tentativeID ||
        r.tentative_id ||
        r.tentativeId;
      const orig = Number(r.QTY || 0);
      const sentOut = tid ? producedByTentative[tid] || 0 : 0;
      const remaining = orig - sentOut;
      if (remaining > 0) {
        const newRow = { ...r, Remaining_QTY: remaining };
        (out[d] ||= []).push(newRow);
      }
    }
    for (const k of Object.keys(out)) {
      out[k].sort(
        (a, b) =>
          (a.Operator || "").localeCompare(b.Operator || "") ||
          (a.Part_Description || "").localeCompare(b.Part_Description || "")
      );
    }
    return out;
  }, [rowsTent, producedByTentative]);

  const byDateDaily = useMemo(() => {
    const m = {};
    for (const r of rowsDaily) {
      const d = r.Date?.slice(0, 10);
      if (!d) continue;
      (m[d] ||= []).push(r);
    }
    for (const k of Object.keys(m)) {
      m[k].sort((a, b) => {
        const da = Number.isFinite(+a.DisplayID) ? +a.DisplayID : 9999;
        const db = Number.isFinite(+b.DisplayID) ? +b.DisplayID : 9999;
        if (da !== db) return da - db;
        return (
          (a.Section || "").localeCompare(b.Section || "") ||
          (a.Work_Station || "").localeCompare(b.Work_Station || "") ||
          (a.Operator || "").localeCompare(b.Operator || "")
        );
      });
    }
    return m;
  }, [rowsDaily]);

  const dateColumns = useMemo(
    () => datesBetweenISO(start, end),
    [start, end]
  );

  /* ----------------- DRAG & DROP HANDLERS ----------------- */

  const handleDragStart = (e, type, item, sourceDate) => {
    const dragData = { type, data: item, sourceDate };
    setDraggedItem(dragData);
    setIsDragging(true);
    e.dataTransfer.effectAllowed = "copyMove";
    e.dataTransfer.setData("text/plain", JSON.stringify(dragData));
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
    setDropTarget(null);
    setIsDragging(false);
  };

  const handleDragOver = (e, type, date) => {
    e.preventDefault();
    if (!draggedItem) return;

    // Allow all drop combinations:
    // - daily → daily (internal move)
    // - daily → tentative (copy)
    // - tentative → tentative (internal move)
    // - tentative → daily (copy)
    const canDrop = true; // All combinations allowed now

    if (canDrop) {
      setDropTarget({ type, date });
      e.dataTransfer.dropEffect = draggedItem.type === type ? "move" : "copy";
    }
  };

  const handleDragLeave = () => {
    setDropTarget(null);
  };

  const handleDrop = async (e, targetType, targetDate) => {
    e.preventDefault();
    e.stopPropagation();

    if (!draggedItem) return;

    const { type: sourceType, data: item, sourceDate } = draggedItem;

    // Reset drag state
    setDraggedItem(null);
    setDropTarget(null);
    setIsDragging(false);

    // Determine action type
    const isSameType = sourceType === targetType;
    const isSameDate = sourceDate === targetDate;

    // If same item, same date, same section - no action
    if (isSameType && isSameDate) {
      return;
    }

    // CASE 1: Within Tentative (Move by UPDATE)
    if (sourceType === 'tentative' && targetType === 'tentative') {
      await updateTentativeDate(item, targetDate);
      return;
    }

    // CASE 2: Within Daily (Move by UPDATE)
    if (sourceType === 'daily' && targetType === 'daily') {
      await updateDailyDate(item, targetDate);
      return;
    }

    // CASE 3: Daily → Tentative (Copy with confirmation)
    if (sourceType === 'daily' && targetType === 'tentative') {
      setDropConfirm({
        show: true,
        action: 'dailyToTent',
        item,
        targetDate,
        onConfirm: (editedData) => copyDailyToTentative(editedData, targetDate),
      });
      return;
    }

    // CASE 4: Tentative → Daily (Copy with confirmation)
    if (sourceType === 'tentative' && targetType === 'daily') {
      setDropConfirm({
        show: true,
        action: 'tentToDaily',
        item,
        targetDate,
        onConfirm: (editedData) => copyTentativeToDaily(editedData, targetDate),
      });
      return;
    }
  };

  /* ----------------- DROP ACTIONS ----------------- */

  // Update Tentative date (internal move by UPDATE)
  const updateTentativeDate = async (item, newDate) => {
    try {
      const payload = {
        Sr_No: item.Sr_No,
        date: newDate,
      };

      await Axios.post(`https://${Host}/Rigid/tentative/update/date`, {
        changedData: JSON.stringify(payload),
        token,
      });

      alert(`Moved to ${fmt(newDate)}`);
      fetchBoth();
    } catch (e) {
      alert(e?.response?.data?.message || e.message || "Error moving item.");
    }
  };

  // Update Daily date (internal move by UPDATE)
  const updateDailyDate = async (item, newDate) => {
    try {
      const payload = {
        Sr_No: item.Sr_No || item.SR_No,
        date: newDate,
      };

      await Axios.post(`https://${Host}/Rigid/daily/update/date`, {
        changedData: JSON.stringify(payload),
        token,
      });

      alert(`Moved to ${fmt(newDate)}`);
      fetchBoth();
    } catch (e) {
      alert(e?.response?.data?.message || e.message || "Error moving item.");
    }
  };

  // Copy Daily → Tentative
  const copyDailyToTentative = async (editedData, targetDate) => {
    try {
      const payload = {
        employee: editedData.employee,
        date: targetDate,
        qty: Number(editedData.qty || 0),
        customer: editedData.customer || "",
        description: editedData.description || "",
        partNo: editedData.partNo || "",
        internalPartNo: editedData.internalPartNo,
        Tentative_ID: genTentativeId({ internalPartNo: editedData.internalPartNo, date: targetDate }),
      };

      const res = await Axios.post(`https://${Host}/Rigid/tentative/add`, {
        changedData: JSON.stringify(payload),
        token,
      });

      alert(res.data?.message || "Copied to Tentative");
      fetchBoth();
    } catch (e) {
      alert(e?.response?.data?.message || e.message || "Error copying to tentative.");
    }
  };

  // Copy Tentative → Daily
  const copyTentativeToDaily = async (editedData, targetDate) => {
    try {
      const payload = {
        employee: editedData.employee,
        date: targetDate,
        qty: Number(editedData.qty || 0),
        partNo: editedData.partNo,
        internalPartNo: editedData.internalPartNo,
        description: editedData.description,
        customer: editedData.customer,
        workStation: editedData.workStation || "",
        tentativeID: editedData.Tentative_ID || "",
        user,
      };

      const res = await Axios.post(`https://${Host}/Rigid/tentative/add/Schedule`, {
        changedData: JSON.stringify(payload),
        token,
      });

      alert(res.data?.message || "Copied to Daily");
      fetchBoth();
    } catch (e) {
      alert(e?.response?.data?.message || e.message || "Error copying to daily.");
    }
  };

  /* ----------------- Tentative -> Daily (send button) ----------------- */
  const openSendForItem = (r) => {
    setSendForm({
      date: r.Date?.slice(0, 10) || todayISO(),
      employee: r.Operator || "",
      partNo: r.Part_No || "",
      internalPartNo: r.Internal_Part_No || "",
      qty: Number((r.Remaining_QTY ?? r.QTY) || 0),
      customer: r.Customer || "",
      description: r.Part_Description || "",
      Work_Station: "",
      Tentative_ID: r.Tentative_ID || "",
    });
    setOpenSend(true);
  };

  const submitSend = async () => {
    try {
      const payload = {
        employee: (sendForm.employee || "").trim(),
        date: sendForm.date,
        qty: Number(sendForm.qty || 0),
        partNo: (sendForm.partNo || "").trim(),
        internalPartNo: (sendForm.internalPartNo || "").trim(),
        description: (sendForm.description || "").trim(),
        customer: (sendForm.customer || "").trim(),
        workStation: (sendForm.Work_Station || "").trim(),
        tentativeID: sendForm.Tentative_ID,
        user,
      };
      const res = await Axios.post(
        `https://${Host}/Rigid/tentative/add/Schedule`,
        {
          changedData: JSON.stringify(payload),
          token,
        }
      );
      alert(res.data?.message || "Sent.");
      setOpenSend(false);
      fetchBoth();
    } catch (e) {
      alert(e?.response?.data?.message || e.message || "Error sending.");
    }
  };

  /* ----------------- Manual -> Tentative (add) ----------------- */
  const openManualForDate = (dateStr) => {
    setManualForm((f) => ({ ...f, date: dateStr }));
    setOpenManual(true);
  };

  const onManualInternalChange = (value) => {
    const partDetails = part_dataset.find(
      (x) => x.Part_internalNo === value
    );
    if (partDetails) {
      setManualForm((f) => ({
        ...f,
        internalPartNo: value,
        customer: partDetails.Customer || "",
        partNo: partDetails.PartNo || "",
        description: partDetails.Part_description || "",
      }));
    } else {
      setManualForm((f) => ({ ...f, internalPartNo: value }));
    }
  };

  const submitManual = async () => {
    try {
      const payload = {
        employee: (manualForm.employee || "").trim(),
        date: manualForm.date,
        qty: Number(manualForm.qty || 0),
        internalPartNo: (manualForm.internalPartNo || "").trim(),
        description: (manualForm.description || "").trim(),
        customer: (manualForm.customer || "").trim(),
        partNo: (manualForm.partNo || "").trim(),
        poQty: 0,
        shortage: 0,
        totalRequired: Number(manualForm.qty || 0),
        poDate: manualForm.date,
        labels: [],
        Tentative_ID: genTentativeId({
          internalPartNo: manualForm.internalPartNo,
          date: manualForm.date,
        }),
        type: "-F",
        user,
      };
      const res = await Axios.post(
        `https://${Host}/Rigid/tentative/add`,
        {
          changedData: JSON.stringify(payload),
          token,
        }
      );
      alert(res.data?.message || "Added.");
      setOpenManual(false);
      fetchBoth();
    } catch (e) {
      alert(e?.response?.data?.message || e.message || "Error adding.");
    }
  };

  /* ----------------- produced auto-save ----------------- */
  const saveProduced = async (r, producedValue) => {
    const newVal = Number(producedValue ?? 0);
    setRowsDaily((prev) =>
      prev.map((x) =>
        x.Sr_No === r.Sr_No ? { ...x, Produced: newVal } : x
      )
    );
    try {
      const payload = {
        srNo: r.Sr_No || undefined,
        date: r.Date?.slice(0, 10),
        operator: r.Operator,
        partInternalNo: r.Internal_Part_No,
        partNo: r.Part_No,
        produced: newVal,
        user,
      };
      await Axios.post(`https://${Host}/Rigid/daily/produce`, {
        changedData: JSON.stringify(payload),
        token,
      });
    } catch (e) {
      alert(
        e?.response?.data?.message || e.message || "Error saving production."
      );
    }
  };

  const scheduleAutoSave = (r, rawValue) => {
    const k = keyForDaily(r);
    setProdEdit((m) => ({ ...m, [k]: rawValue }));
    if (saveTimers.current[k]) clearTimeout(saveTimers.current[k]);
    saveTimers.current[k] = setTimeout(() => {
      saveProduced(r, rawValue);
      delete saveTimers.current[k];
    }, 500);
  };

  const flushAutoSave = (r) => {
    const k = keyForDaily(r);
    if (saveTimers.current[k]) {
      clearTimeout(saveTimers.current[k]);
      const value = prodEdit[k];
      saveProduced(r, value);
      delete saveTimers.current[k];
    }
  };

  const sectionRank = {
    "FLEX MOLDING": 1,
    "RIGID MOLDING": 2,
    "RIGID SEAT MOLDING": 3,
  };

  return (
    <div className="ts-wrap">
      <div className="ts-toolbar">
        <div className="ts-range">
          <label>
            From:{" "}
            <input
              type="date"
              value={start}
              onChange={(e) => setStart(e.target.value)}
            />
          </label>
          <label>
            To:{" "}
            <input
              type="date"
              value={end}
              onChange={(e) => setEnd(e.target.value)}
            />
          </label>
          <button onClick={fetchBoth}>Refresh</button>
        </div>

        <button
          style={{ marginLeft: 8 }}
          onClick={() => setOpenCapability(true)}
        >
          Employee Capability
        </button>

        <div className="ts-shift">
          <label>
            Department
            <input
              type="text"
              placeholder="CHOOSE DEPARTMENT"
              value={shift}
              onChange={(e) => setShift(e.target.value)}
              list="dept_list"
            />
          </label>
          <datalist id="dept_list">
            <option>Night_Operators</option>
            <option>Management</option>
            <option>Morning_Operators</option>
            <option>Woodshop</option>
          </datalist>
        </div>

        {loading && <div className="ts-status">Loading…</div>}
        {error && <div className="ts-error">{error}</div>}
      </div>

      {/* Drag indicator */}
      {isDragging && (
        <div className="ts-drag-hint">
          {draggedItem?.type === 'tentative' && draggedItem?.type === dropTarget?.type
            ? '🔄 Moving within Tentative'
            : '📋 Copying to different section'}
        </div>
      )}

      <div className="ts-grid">
        {dateColumns.map((d) => {
          const tent = byDateTentFiltered[d] || [];
          const daily = byDateDaily[d] || [];

          const sections = {};
          for (const r of daily) {
            const sec = r.Section || "Unassigned";
            const ws = r.Work_Station || "Unspecified";
            const disp = Number.isFinite(+r.DisplayID) ? +r.DisplayID : 9999;
            (sections[sec] ??= { minDisp: disp, machines: {} });
            if (disp < sections[sec].minDisp) sections[sec].minDisp = disp;
            (sections[sec].machines[ws] ??= []).push(r);
          }

          const orderedSections = Object.keys(sections).sort((a, b) => {
            const ra = sectionRank[a] ?? 999;
            const rb = sectionRank[b] ?? 999;
            if (ra !== rb) return ra - rb;
            const da = sections[a].minDisp;
            const db = sections[b].minDisp;
            if (da !== db) return da - db;
            return a.localeCompare(b);
          });

          const posSummary = getPositionSummaryForDate(d);
          const othersTotal = Object.values(posSummary.other).reduce(
            (sum, v) => sum + v,
            0
          );

          const isDailyDropTarget = dropTarget?.type === 'daily' && dropTarget?.date === d;
          const isTentDropTarget = dropTarget?.type === 'tentative' && dropTarget?.date === d;

          // Determine if this is a move (same type) or copy (different type)
          const isMove = draggedItem && dropTarget && draggedItem.type === dropTarget.type;
          const dailyDropClass = isDailyDropTarget ? (isMove ? 'ts-drop-target-move' : 'ts-drop-target') : '';
          const tentDropClass = isTentDropTarget ? (isMove ? 'ts-drop-target-move' : 'ts-drop-target') : '';

          return (
            <div className="ts-col" key={d}>
              <div className="ts-col-header">
                <div className="ts-date-lg">{fmt(d)}</div>
              </div>

              <div className="ts-col-body">
                {/* ---------- TOP: Daily Records ---------- */}
                <div
                  className={`ts-pane ts-pane--daily ${dailyDropClass}`}
                  onDragOver={(e) => handleDragOver(e, 'daily', d)}
                  onDragLeave={handleDragLeave}
                  onDrop={(e) => handleDrop(e, 'daily', d)}
                >
                  <div className="ts-pane-title">
                    <div className="ts-pane-title-main">
                      <span>DAILY RECORDS</span>
                      <span className="ts-count">{daily.length}</span>
                    </div>
                  </div>

                  <div className="vr-sections">
                    {orderedSections.length === 0 && (
                      <div className="ts-empty">—</div>
                    )}

                    {orderedSections.map((sec) => {
                      const rowsAll = Object.values(
                        sections[sec].machines
                      ).flat();
                      rowsAll.sort(
                        (a, b) =>
                          (a.Operator || "").localeCompare(
                            b.Operator || ""
                          ) ||
                          (a.Part_internalNo || "").localeCompare(
                            b.Part_internalNo || ""
                          ) ||
                          (a.Work_Station || "").localeCompare(
                            b.Work_Station || ""
                          )
                      );

                      return (
                        <div className="vr-section" key={sec}>
                          <table className="vr-table vr-compact">
                            <colgroup>
                              <col style={{ width: "24%" }} />
                              <col style={{ width: "40%" }} />
                              <col style={{ width: "8%" }} />
                              <col style={{ width: "14%" }} />
                              <col style={{ width: "16%" }} />
                            </colgroup>
                            <thead>
                              <tr>
                                <th
                                  colSpan="5"
                                  className="vr-section-header"
                                >
                                  {sec}
                                </th>
                              </tr>
                              <tr>
                                <th>OPERATOR</th>
                                <th>PART INTERNAL NO</th>
                                <th className="ta-r">TARGET</th>
                                <th className="ta-r">PRODUCED</th>
                                <th>WORK STATION</th>
                              </tr>
                            </thead>
                            <tbody>
                              {rowsAll.map((r, i) => {
                                const k = keyForDaily(r);
                                const value =
                                  prodEdit[k] ??
                                  (Number.isFinite(+r.Produced)
                                    ? +r.Produced
                                    : 0);
                                return (
                                  <tr
                                    key={r.Sr_No ?? `R${i}`}
                                    draggable
                                    onDragStart={(e) =>
                                      handleDragStart(e, 'daily', r, d)
                                    }
                                    onDragEnd={handleDragEnd}
                                    className="draggable-row"
                                  >
                                    <td className="vr-opr">
                                      {r.Operator || ""}
                                    </td>
                                    <td className="vr-part">
                                      {r.Internal_Part_No || ""}
                                    </td>
                                    <td className="ta-r vr-target">
                                      {Number.isFinite(+r.Target)
                                        ? +r.Target
                                        : ""}
                                    </td>
                                    <td className="ta-r">
                                      <div className="vr-prod-cell">
                                        <input
                                          type="number"
                                          min="0"
                                          className="vr-prod-input"
                                          value={value}
                                          onChange={(e) =>
                                            scheduleAutoSave(
                                              r,
                                              e.target.value
                                            )
                                          }
                                          onBlur={() =>
                                            flushAutoSave(r)
                                          }
                                        />
                                      </div>
                                    </td>
                                    <td className="vr-ws">
                                      {r.Work_Station || ""}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <hr />

                {/* ---------- BOTTOM: Tentative ---------- */}
                <div
                  className={`ts-pane ts-pane--tent ${tentDropClass}`}
                  onDragOver={(e) => handleDragOver(e, 'tentative', d)}
                  onDragLeave={handleDragLeave}
                  onDrop={(e) => handleDrop(e, 'tentative', d)}
                >
                  <div className="ts-pane-title ts-pane-title--tent">
                    <div className="ts-pane-title-main">
                      <span>TENTATIVE</span>
                      <span className="ts-count">{tent.length}</span>
                    </div>
                    <div className="ts-pane-title-extra">
                      {shift && shift.length > 1 ? (
                        <div className="ts-role-chips">
                          <span className="ts-role-chip ts-role-chip--rigid">
                            <span className="ts-role-label">
                              Rigid Op
                            </span>
                            <span className="ts-role-value">
                              {posSummary.rigid}
                            </span>
                          </span>
                          <span className="ts-role-chip ts-role-chip--flex">
                            <span className="ts-role-label">
                              Flex Op
                            </span>
                            <span className="ts-role-value">
                              {posSummary.flex}
                            </span>
                          </span>
                          <span className="ts-role-chip ts-role-chip--floater">
                            <span className="ts-role-label">
                              Floater
                            </span>
                            <span className="ts-role-value">
                              {posSummary.floater}
                            </span>
                          </span>
                          {othersTotal > 0 && (
                            <button
                              type="button"
                              className="ts-role-more"
                              title="View other positions for this day"
                              onClick={() => setRolePopupDate(d)}
                            >
                              Others {othersTotal}
                            </button>
                          )}
                        </div>
                      ) : null}
                      <button
                        className="ts-header-add"
                        title="Add manual Tentative"
                        onClick={() => openManualForDate(d)}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div className="ts-pane-list">
                    {tent.length === 0 && (
                      <div className="ts-empty">—</div>
                    )}

                    {tent.map((r, i) => (
                      <div
                        className="ts-item"
                        key={r.Sr_No ?? `T${i}`}
                        draggable
                        onDragStart={(e) =>
                          handleDragStart(e, 'tentative', r, d)
                        }
                        onDragEnd={handleDragEnd}
                      >
                        <button
                          className="ts-item-send"
                          title="Send this to Daily"
                          onClick={() => openSendForItem(r)}
                        >
                          →
                        </button>

                        <div className="ts-item-main">
                          <div className="ts-item-top">
                            <span className="ts-qty">
                              {r.Remaining_QTY ??
                                r.QTY ??
                                0}
                            </span>
                            <span className="ts-op">
                              {r.Operator}
                            </span>
                            <span className="ts-partno">
                              {r.Internal_Part_No ||
                                r.Part_No ||
                                ""}
                            </span>
                          </div>
                          <div className="ts-meta">
                            {r.Part_Description && (
                              <span className="ts-desc">
                                {r.Part_Description}
                              </span>
                            )}
                            {r.Customer && (
                              <span className="ts-cust">
                                {r.Customer}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* ----------------- Send dialog ----------------- */}
      {openSend && (
        <div className="ts-modal">
          <div className="ts-modal-card">
            <div className="ts-modal-title">Send to Daily</div>

            <div className="ts-form">
              <label>
                Date
                <input
                  type="date"
                  value={sendForm.date}
                  onChange={(e) =>
                    setSendForm((f) => ({
                      ...f,
                      date: e.target.value,
                    }))
                  }
                />
              </label>

              <label>
                Operator
                <input
                  value={sendForm.employee}
                  onChange={(e) =>
                    setSendForm((f) => ({
                      ...f,
                      employee: e.target.value,
                    }))
                  }
                  list="employees"
                />
                <datalist id="employees">
                  {employees.map((e) => (
                    <option
                      key={e.Emp_ID || e}
                      value={e.Name || e}
                    />
                  ))}
                </datalist>
              </label>

              <label>
                Part No
                <input value={sendForm.partNo} readOnly />
              </label>

              <label>
                Internal Part No
                <input
                  value={sendForm.internalPartNo}
                  readOnly
                />
              </label>

              <label>
                Qty
                <input
                  type="number"
                  min="0"
                  value={sendForm.qty}
                  onChange={(e) =>
                    setSendForm((f) => ({
                      ...f,
                      qty: e.target.value,
                    }))
                  }
                />
              </label>

              <label>
                Customer
                <input value={sendForm.customer} readOnly />
              </label>

              <label>
                Work Station
                <input
                  value={sendForm.Work_Station}
                  onChange={(e) =>
                    setSendForm((f) => ({
                      ...f,
                      Work_Station: e.target.value,
                    }))
                  }
                  list="Work_station"
                />
                <datalist id="Work_station">
                  <option key="empty-option"></option>
                  {Machine_list.map((x, idx) => (
                    <option key={x.Machines + idx}>
                      {x.Machines}
                    </option>
                  ))}
                </datalist>
              </label>

              <label style={{ gridColumn: "1 / span 2" }}>
                Description
                <textarea
                  rows={2}
                  value={sendForm.description}
                  readOnly
                />
              </label>
            </div>

            <div className="ts-actions">
              <button onClick={submitSend}>Send</button>
              <button
                className="ts-secondary"
                onClick={() => setOpenSend(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ----------------- Manual add dialog ----------------- */}
      {openManual && (
        <div className="ts-modal">
          <div className="ts-modal-card">
            <div className="ts-modal-title">Add to Tentative</div>

            <div className="ts-form">
              <label>
                Date
                <input
                  type="date"
                  value={manualForm.date}
                  onChange={(e) =>
                    setManualForm((f) => ({
                      ...f,
                      date: e.target.value,
                    }))
                  }
                />
              </label>

              <label>
                Operator
                <input
                  value={manualForm.employee}
                  onChange={(e) =>
                    setManualForm((f) => ({
                      ...f,
                      employee: e.target.value,
                    }))
                  }
                  list="employees"
                />
                <datalist id="employees">
                  {employees.map((e) => (
                    <option
                      key={e.Emp_ID || e}
                      value={e.Name || e}
                    />
                  ))}
                </datalist>
              </label>

              <label>
                Internal Part No
                <input
                  value={manualForm.internalPartNo}
                  onChange={(e) =>
                    onManualInternalChange(e.target.value)
                  }
                  list="part_internal_list"
                />
                <datalist id="part_internal_list">
                  {part_dataset.map((p) => (
                    <option
                      key={p.Part_internalNo}
                      value={p.Part_internalNo}
                    />
                  ))}
                </datalist>
              </label>

              <label>
                Part No
                <input value={manualForm.partNo} readOnly />
              </label>

              <label>
                Customer
                <input
                  value={manualForm.customer}
                  readOnly
                />
              </label>

              <label>
                Qty
                <input
                  type="number"
                  min="0"
                  value={manualForm.qty}
                  onChange={(e) =>
                    setManualForm((f) => ({
                      ...f,
                      qty: e.target.value,
                    }))
                  }
                />
              </label>

              <label>
                Work Station
                <input
                  value={manualForm.Work_Station}
                  onChange={(e) =>
                    setManualForm((f) => ({
                      ...f,
                      Work_Station: e.target.value,
                    }))
                  }
                  list="Work_station"
                />
                <datalist id="Work_station">
                  <option key="empty-option"></option>
                  {Machine_list.map((x, idx) => (
                    <option key={x.Machines + idx}>
                      {x.Machines}
                    </option>
                  ))}
                </datalist>
              </label>

              <label style={{ gridColumn: "1 / span 2" }}>
                Description
                <textarea
                  rows={2}
                  value={manualForm.description}
                  onChange={(e) =>
                    setManualForm((f) => ({
                      ...f,
                      description: e.target.value,
                    }))
                  }
                />
              </label>
            </div>

            <div className="ts-actions">
              <button onClick={submitManual}>Add</button>
              <button
                className="ts-secondary"
                onClick={() => setOpenManual(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ----------------- Capability popup ----------------- */}
      {openCapability && (
        <div className="ts-modal">
          <div className="ts-modal-card ts-modal-cap">
            <div className="ts-modal-title">
              Employees Capability (Max Produced per Part)
            </div>

            <div className="ts-cap-table-wrap">
              <table className="ts-cap-table">
                <thead>
                  <tr>
                    <th>Operator</th>
                    <th>Part Internal No</th>
                    <th>Section</th>
                    <th className="ta-r">Capability</th>
                  </tr>
                </thead>
                <tbody>
                  {(!employees_capability ||
                    employees_capability.length === 0) && (
                      <tr>
                        <td
                          colSpan={6}
                          style={{
                            textAlign: "center",
                            padding: "8px 0",
                          }}
                        >
                          No capability data.
                        </td>
                      </tr>
                    )}

                  {employees_capability &&
                    employees_capability.map((row, idx) => (
                      <tr key={idx}>
                        <td>{row.Operator}</td>
                        <td>{row.Part_internalNo}</td>
                        <td>{row.Section}</td>
                        <td className="ta-r">
                          {row.capability_per_part}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            <div className="ts-actions">
              <button
                className="ts-secondary"
                onClick={() => setOpenCapability(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ----------------- Position breakdown popup ----------------- */}
      {rolePopupDate && (
        <div className="ts-modal" onClick={() => setRolePopupDate(null)}>
          <div
            className="ts-modal-card ts-modal-roles"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ts-modal-title">
              Employee positions – {fmt(rolePopupDate)}
            </div>
            <div className="ts-cap-table-wrap">
              <table className="ts-cap-table">
                <thead>
                  <tr>
                    <th>Position</th>
                    <th className="ta-r">Employees</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    const s = getPositionSummaryForDate(rolePopupDate);
                    const rows = [];

                    rows.push(
                      <tr key="rigid">
                        <td>Rigid Operator</td>
                        <td className="ta-r">{s.rigid}</td>
                      </tr>
                    );
                    rows.push(
                      <tr key="flex">
                        <td>Flex operator</td>
                        <td className="ta-r">{s.flex}</td>
                      </tr>
                    );
                    rows.push(
                      <tr key="floater">
                        <td>Floater</td>
                        <td className="ta-r">{s.floater}</td>
                      </tr>
                    );

                    const otherKeys = Object.keys(s.other).sort();
                    if (otherKeys.length) {
                      rows.push(
                        <tr key="sep">
                          <td colSpan={2} className="ts-roles-sep">
                            Other positions
                          </td>
                        </tr>
                      );
                      otherKeys.forEach((pos) => {
                        rows.push(
                          <tr key={pos}>
                            <td>{pos}</td>
                            <td className="ta-r">{s.other[pos]}</td>
                          </tr>
                        );
                      });
                    }

                    if (!rows.length) {
                      rows.push(
                        <tr key="empty">
                          <td colSpan={2} style={{ textAlign: "center" }}>
                            No employees for this date.
                          </td>
                        </tr>
                      );
                    }

                    return rows;
                  })()}
                </tbody>
              </table>
            </div>
            <div className="ts-actions">
              <button
                className="ts-secondary"
                onClick={() => setRolePopupDate(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ----------------- DROP CONFIRMATION DIALOG ----------------- */}
      {dropConfirm?.show && (
        <DropConfirmDialog
          action={dropConfirm.action}
          item={dropConfirm.item}
          targetDate={dropConfirm.targetDate}
          employees={employees}
          Machine_list={Machine_list}
          part_dataset={part_dataset}
          onConfirm={(editedData) => {
            dropConfirm.onConfirm(editedData);
            setDropConfirm(null);
          }}
          onCancel={() => setDropConfirm(null)}
        />
      )}
    </div>
  );
}

/* ----------------- DROP CONFIRMATION DIALOG COMPONENT ----------------- */
function DropConfirmDialog({
  action,
  item,
  targetDate,
  employees,
  Machine_list,
  part_dataset,
  onConfirm,
  onCancel,
}) {
  const [formData, setFormData] = useState(() => {
    if (action === 'dailyToTent') {
      return {
        employee: item.Operator || "",
        internalPartNo: item.Internal_Part_No || item.Part_internalNo || "",
        partNo: item.Part_No || item.PartNo || "",
        customer: item.Customer || "",
        description: item.Part_Description || item.Part_description || "",
        qty: Number(item.Target || item.QTY || 0),
        workStation: item.Work_Station || item.work_station || "",
      };
    } else {
      // tentToDaily
      return {
        employee: item.Operator || "",
        internalPartNo: item.Internal_Part_No || "",
        partNo: item.Part_No || "",
        customer: item.Customer || "",
        description: item.Part_Description || "",
        qty: Number(item.Remaining_QTY || 0),
        workStation: "",
        Tentative_ID: item.Tentative_ID || "",
      };
    }
  });

  const title = action === 'dailyToTent'
    ? `Copy to Tentative (${fmt(targetDate)})`
    : `Copy to Daily Records (${fmt(targetDate)})`;

  const handleInternalPartChange = (value) => {
    const partDetails = part_dataset.find(
      (x) => x.Part_internalNo === value
    );
    if (partDetails) {
      setFormData((f) => ({
        ...f,
        internalPartNo: value,
        customer: partDetails.Customer || "",
        partNo: partDetails.PartNo || "",
        description: partDetails.Part_description || "",
      }));
    } else {
      setFormData((f) => ({ ...f, internalPartNo: value }));
    }
  };

  return (
    <div className="ts-modal ts-modal-drop-confirm">
      <div className="ts-modal-card">
        <div className="ts-modal-title">{title}</div>

        <div className="ts-form">
          <label>
            Operator
            <input
              value={formData.employee}
              onChange={(e) =>
                setFormData((f) => ({
                  ...f,
                  employee: e.target.value,
                }))
              }
              list="employees_drop"
            />
            <datalist id="employees_drop">
              {employees.map((e) => (
                <option
                  key={e.Emp_ID || e}
                  value={e.Name || e}
                />
              ))}
            </datalist>
          </label>

          <label>
            Qty
            <input
              type="number"
              min="0"
              value={formData.qty}
              onChange={(e) =>
                setFormData((f) => ({
                  ...f,
                  qty: e.target.value,
                }))
              }
            />
          </label>

          <label>
            Internal Part No
            <input
              value={formData.internalPartNo}
              onChange={(e) => handleInternalPartChange(e.target.value)}
              list="part_internal_drop"
              readOnly={action === 'dailyToTent'} // Keep internal part no same
            />
            <datalist id="part_internal_drop">
              {part_dataset.map((p) => (
                <option
                  key={p.Part_internalNo}
                  value={p.Part_internalNo}
                />
              ))}
            </datalist>
          </label>

          <label>
            Part No
            <input value={formData.partNo} readOnly />
          </label>

          <label>
            Customer
            <input value={formData.customer} readOnly />
          </label>

          {action === 'tentToDaily' && (
            <label>
              Work Station
              <input
                value={formData.workStation}
                onChange={(e) =>
                  setFormData((f) => ({
                    ...f,
                    workStation: e.target.value,
                  }))
                }
                list="Work_station_drop"
              />
              <datalist id="Work_station_drop">
                <option key="empty-option"></option>
                {Machine_list.map((x, idx) => (
                  <option key={x.Machines + idx}>
                    {x.Machines}
                  </option>
                ))}
              </datalist>
            </label>
          )}

          <label style={{ gridColumn: "1 / span 2" }}>
            Description
            <textarea
              rows={2}
              value={formData.description}
              readOnly
            />
          </label>
        </div>

        <div className="ts-actions">
          <button onClick={() => onConfirm(formData)}>
            Confirm Copy
          </button>
          <button
            className="ts-secondary"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}